import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './BottomNav.module.css';

const BottomNav = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    let timeoutId;

    const handleActivity = () => {
      setIsVisible(true);
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };

    // Initial setup
    handleActivity();

    // Add event listeners
    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('mousedown', handleActivity);
    window.addEventListener('touchstart', handleActivity);
    window.addEventListener('scroll', handleActivity, true); // Use capture phase for scroll

    // Cleanup
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('mousedown', handleActivity);
      window.removeEventListener('touchstart', handleActivity);
      window.removeEventListener('scroll', handleActivity, true);
    };
  }, []);

  return (
    <nav className={`${styles.bottomNav} ${isVisible ? styles.visible : styles.hidden}`}>
      <NavLink to="/app/dashboard" className={styles.navLink} activeClassName={styles.active}>
        <img src="/assets/icons/home.svg" alt="Dashboard" />
        <span>Dashboard</span>
      </NavLink>
      <NavLink to="/app/orders" className={styles.navLink} activeClassName={styles.active}>
        <img src="/assets/icons/package.svg" alt="Orders" />
        <span>Orders</span>
      </NavLink>
      <NavLink to="/app/sales" className={styles.navLink} activeClassName={styles.active}>
        <img src="/assets/icons/trending-up.svg" alt="Sales" />
        <span>Sales</span>
      </NavLink>
      <NavLink to="/app/products" className={styles.navLink} activeClassName={styles.active}>
        <img src="/assets/icons/shopping-cart.svg" alt="Products" />
        <span>Products</span>
      </NavLink>
      <NavLink to="/app/more" className={styles.navLink} activeClassName={styles.active}>
        <img src="/assets/icons/plus.svg" alt="More" />
        <span>More</span>
      </NavLink>
    </nav>
  );
};

export default BottomNav; 